<script>
	import { afterNavigate, goto } from "$app/navigation";
	import { navigating } from "$app/stores";
	import { utilityButtons } from "$lib/store";
	import { dropRight } from "lodash-es";
	import { onMount } from "svelte";

	let navStack = [];

	onMount(() => {
		checkHistoryEmpty();
	});

	afterNavigate((n) => {
		if (n.type === "enter" || checkHistoryEmpty()) return;

		if (n.type === "popstate") {
			// Nav back
			navStack = dropRight(navStack, Math.abs(n.delta));
		} else {
			// Link/goto/forward
			navStack = [...navStack, n.from];
		}
	});

	function checkHistoryEmpty() {
		if (history.length === 0) {
			// If the component reloads, I think the page looses history
			// but our navStack is still populated. We should consider it
			// now empty so we don't show the back button;
			navStack = [];
			return true;
		}
		return false;
	}
</script>

{#if !(!!$navigating && $navigating.type !== "leave") && (navStack.length || $utilityButtons.length)}
	<div class="relative h-12 z-40 bg-white border sticky top-$safe-area-top shadow-md">
		<button
			class="absolute left-0 top-0 flex h-full mx-3 items-center gap-3"
			on:click={() => (navStack.length ? history.back() : goto("/"))}
		>
			<span class="i-ph:arrow-left text-3xl" /> Back
		</button>
		<div class="absolute right-0 top-0 flex h-full justify-self-end">
			{#each $utilityButtons as btn}
				<button
					class="flex items-center justify-center px-1.6 border-l disabled:text-gray-400"
					on:click={(e) => btn.fn(e.currentTarget)}
				>
					<span class="{btn.class} text-3xl" />
				</button>
			{/each}
		</div>
	</div>
{/if}
